import {createApi} from '@reduxjs/toolkit/query/react';

import {metadaBaseQuery} from '../baseQuery/metadaBaseQuery';

export const metadaApi = createApi({
  baseQuery: metadaBaseQuery,
  reducerPath: 'rtk_metadaApi',
  tagTypes: [
    'serviceCase',
    'orderVariants',
    'serviceOrder',
    'serviceOrderCommercial',
    'serviceOrderComplaint',
    'serviceOrderContract',
    'serviceOrderInsurance',
    'serviceOrderInternal',
    'serviceOrderWarranty',
    'carisExport',
    'abraConfiguration',
    'invoiceCostItemSubcontracts',
    'operationDefaults',
    'serviceRentalOrder',
    'serviceOrderVariants',
    'handOver',
    'konzulta-credentials',
    'checkIn',
    'serviceJobs',
    'employeeOrganisationalDataSales',
    'dgv4-preset',
    'company',
    'warehouses',
    'warehouse',
    'accountingDictionary',
    'supplierDiscountGroups',
    'employeeLink',
    'supplierOrders',
    'supplierOrderVariants',
    'manufacturers',
    'priceList',
    'stockSvailabilityId',
    'serviceCaseType',
    'serviceJob',
    'serviceJobActions',
    'serviceOrders',
    'serviceOrderJobs',
    'serviceOrderJob',
    'serviceOrderType',
    'serviceOrderVariant',
    'workSplitting',
    'applicationLawList',
    'costCentersList',
    'insuranceCompaniesList',
    'insuranceTypesList',
    'providersList',
    'technicansList',
    'labourCatalogItem',
    'accountingContextCodeTable',
    'employeeAuthorizationIntegration',
    'workBasketItems',
    'catalogCategoryList',
    'workClassificationList',
    'workType',
    'workTypeList',
    'workBasketItem',
    'dictionary',
    'postponeJob',
    'postponeJobs',
    'orderActions',
    'vehicleCustomer',
    'orderDiscount',
    'serviceCaseTotalAmount',
    'serviceOrderTotalAmount',
    'serviceOrderJobTotalAmount',
    'authorizationProfiles',
    'authorizationProfilesByIntegrationId',
    'authorizationOperations',
    'serviceActions',
    'materialBasketItems',
    'itemsBasketActions',
    'employeeOrganisationalData',
    'employeePersonalData',
    'enums',
    'employeeActions',
    'checkout',
    'goodwillItemRatio',
    'metadaNote',
    'employeeCompetence',
    'employeeCompetences',
    'employeeCostCenter',
    'employeeCostCenters',
    'vehicleGroup',
    'vehicleGroups',
    'employeeWorkTeam',
    'employeeWorkTeams',
    'employeeProfession',
    'employeeProfessions',
    'tireSet',
    'tireOrder',
    'materialDiscountGroup',
    'materialDiscountGroupItem',
    'tireManufacturers',
    'tireLocations',
    'tireSetVehicle',
    'tireSetCustomer',
    'serviceOrderMandatoryFields',
    'serviceOrderCheckoutRestriction',
    'serviceCaseIntergations',
    'smallUnitMaterial',
    'serviceCaseXentryOrderSynchronization',
    'audatexCalculationsUserSettings',
    'myClaimCalculationsUserSettings',
    'pendingServiceItems',
    'pendingServiceOrderReturn',
    'customerServiceContract',
    'evaClaimDetail',
    'evaClaimAdditionalInformation',
    'mazdaAdditionalInformation',
    'workItemMazdaAdditionalInformation',
    'mazdaPreauthorization',
    'mazdaClaim',
    'hyundaiAs1qUserOptions',
    // Warehouse — Receive Note (granular)
    'receiveNoteState',
    'receiveNoteInfo',
    'receiveNoteFastTrackItems',
    'receiveNoteFastTrackIssues',
    'receiveNoteItemCore',
    'receiveNoteBasketItems',
    'receiveNoteBasketTotalPrice',
    // Warehouse — other
    'deliveryNote',
    'deliveryNoteItem',
    'headerDynamicActions',
    'receiveNoteCorrections',
    'receiveNoteCorrectionBasket',
    'receiveNoteCorrectionItems',
    'article',
    'availabilityArticle',
    'articleCategory',
    'partsRequest',
    'receiveNoteTotalPrice',
    'receiveNoteCorrectionActions',
    'supportedPriceList',
    'handlingUnits',
    'dispensingUnitPresets',
    'transferOrderVariants',
    'transferOrders',
    'transferOrderItems',
    'transferOrderBasket',
    'directSaleVariants',
    'directSales',
    'directSaleMaterialItems',
    'directSaleLabourItems',
    'directSaleMaterialBasket',
    'directSaleLabourBasket',
    'partsRequestReturnBasket',
    'directSaleVariantDefaultVarehousesPriority',
    'directSaleCheckout',
    'workRateTypes',
    'materialPriceTypes',
    'directSaleTypes',
    'reservations',
    'directSaleDiscount',
    'discountApplicationMethod',
    'serviceOrderIssueVariants',
    'serviceOrderIssueNotes',
    'serviceOrderIssueNoteBasket',
    'issueNotes',
    'issueNoteCorrections',
    'costCorrections',
    'supplerOrderVariants',
    'supplerOrderVariantSuppliers',
    'supplierOrderItem',
    'supplierOrderMaterialBasket',
    'supplierOrderType',
    'supplierArticles',
    'serviceOrderReturns',
    'directSaleLastActiveByCustomerId',
    'marketingCode',
    'articleUpdateJobs',
    'articleUpdateJobBasket',
    'fastTrackIssues',
    'fastTrackBasket',
    // Insurance
    'insurance',
    'orderProfitability',
    'labourCatalogCategory',
    'treeFolder',
    'minorUnitMaterial',
    'materialDiscountGroups',
    'materialDiscountGroupDiscounts',
    'customerContract',
    'customerContractLabourDiscount',
    'customerContractMaterialDiscount',
    'invidualPriceLabour',
    'invidualPriceMaterial',
    'customerContractAssignedCustomer',
    'customerContractAssignedCustomerValidity',
    'profitabilityHistory',
    'tiresInventoryGeneralSettings',
    'orderCustomerContract',
    'customerCustomerContracts',
    'vehicleCampaign',
    'materialOrderItem',
    'oneTimeSaleForMaterialItem',
    'customerPaymentSettings',
    'BankTransferSetting',
    'packageCategory',
    'servicePackage',
    'serviceRequestDetail',
    'orderIntegration',
    'servicePackageLabourItem',
    'servicePackageMaterialItem',
    'servicePackageLabourItems',
    'servicePackageMaterialItems',
    'servicePackages',
    'servicePackageCategories',
    'measurementUnit',
    'mandatoryFields',
    'labourRate',
    'xentryOrders',
    'previousRequestsCount',
    'tireIds',
    'paymentTypes',
    'serviceOrderVariantDeposit',
    'serviceItemsExternalHistory',
    'serviceOrderGroups',
    'serviceOrderGroup',
    'serviceOrderVariantAccounting',
    'serviceCaseTypes',
    'afsBillingInformation',
    'afsAllowedCustomer',
    'afsPaymentById',
    'afsPaymentsList',
    'afsCorrectionDiscardPaymentsList',
    'afsPaymentIssueRestriction',
    'afsCheckout',
    'afsPaymentByIdList',
    'tiresInventoryDefaultStoreUntil',
    'tireWarehousesAll',
    'tireWarehouseSettings',
    'tireWarehouse',
    'generalSettings',
    'employeeCompetenceLink',
    'tireWarehouseGeneratorSettings',
    'tireWarehouseStorageLocationDetail',
    'tireSetLocation',
    'tireAspectRatios',
    'tireAspectRatio',
    'tireWidths',
    'tireWidth',
    'tireLoadIndexes',
    'tireLoadIndex',
    'tireRims',
    'tireRim',
    'tireSpeedRatios',
    'tireSpeedRatio',
    'tireCategories',
    'tireCategory',
    'tireConditions',
    'tireCondition',
    'workItemIntegration',
    'materialItemIntegration',
    'integratedServices',
    'serviceOrderVariantReporting',
    'labourUnits',
    'labourRates',
    'hourlyRates',
    'vehicleClasses',
    'afsPaymentTransactions',
    'afsPaymentTemplates',
    'partDepartment',
    'partDepartmentTypes',
    'serviceOrderVariantWarehousePriority',
    'serviceOrderVariantIntegration',
    'orderVehicleClass',
    'integrationCustomer',
    'serviceCaseOrderCount',
    'serviceVehicle',
    'serviceVehicleAdditionalInformation',
    'selectableMaterial',
    'selectableMaterialItem',
    'facebookCredentials',
    'metaAuthorization',
    'facebookLoginUrl',
    'customerServiceContracts',
    'partMovementsCount',
    'hyundaiServiceInspection',
    'hyundaiServiceInspectionMileages',
    'hyundaiServiceInspectionModels',
    'serviceOrderSmallUnitMaterial',
    'serviceOrderMinimumMargin',
    'missingServiceOrderMandatoryFields',
    'spaces',
    'space',
    'businessCaseServiceCases',
    'checkoutLink',
    'serviceCaseByVehicleCount',
    'accountingMatrixDatagridRecord',
  ],
  endpoints: () => ({}),
});
